module.exports = __webpack_public_path__ + "static/media/denzel.3029ec47.jpg";